<template>
  <div>
    <div class="columns">
      <div class="column is-6">
        <h2 class="title is-3">Key aanmaken</h2>

        <div class="field">
          <label class="label">Omschrijving</label>
          <div class="control">
            <input class="input" type="text" placeholder="Omschrijving" v-model="keyDescription">
          </div>
        </div>

        <hr v-if="generatedKey || generatedSecret">

        <div class="field" v-if="generatedKey">
          <label class="label">Key</label>
          <div class="control">
            <input class="input" type="text" placeholder="Key" v-model="generatedKey" readonly>
          </div>
        </div>

        <div class="field" v-if="generatedSecret">
          <label class="label">Secret</label>
          <div class="control">
            <input class="input" type="text" placeholder="Secret" v-model="generatedSecret" readonly>
          </div>
        </div>

        <a class="button is-primary" :class="{ 'is-loading': isGenerating }" v-on:click="generateKey">Genereer</a>

        <table class="table is-striped spacing-top">
          <thead>
            <tr>
              <th>Omschrijving</th>
              <th>Aangemaakt op</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="key in keys">
              <td>{{key.description}}</td>
              <td>{{key.createdAt | timezone | date}}</td>
              <td>
                <div class="block" @click="deleteKey(key.id)">
                  <span class="tag is-danger">
                    Verwijderen
                    <button class="delete is-small"></button>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="column is-6">
        <div class="message is-primary is-marginless">
          <div class="message-header">
            API keys
          </div>
          <div class="message-body">
            Deze API keys worden gebruikt door third party applications. Met een key kan een applicatie toegang krijgen tot de St. Job API. Wanneer een key niet meer gebruikt word kan deze verwijderd worden.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      keys: 'activeApiKeys'
    })
  },
  data () {
    return {
      isGenerating: false,
      generatedKey: null,
      generatedSecret: null,
      keyDescription: null
    }
  },
  created () {
    try {
      this.$store.dispatch('getActiveApiKeys')
    } catch (error) {
      this.$snackbar.open({
        type: 'is-danger',
        message: 'Er ging iets fout tijdens het ophalen van de actieve API tokens.'
      })
    }
  },
  methods: {
    async deleteKey (id) {
      try {
        await this.$store.dispatch('revokeApiKey', id)
        await this.$store.dispatch('getActiveApiKeys')
      } catch (error) {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het verwijderen van een API key.'
        })
      }
    },
    async generateKey () {
      try {
        const description = this.keyDescription
        const {key, secret} = await this.$store.dispatch('generateApiKey', description)

        this.generatedKey = key
        this.generatedSecret = secret

        await this.$store.dispatch('getActiveApiKeys')
      } catch (error) {
        this.$snackbar.open({
          type: 'is-danger',
          message: 'Er ging iets fout tijdens het genereren van een nieuwe API key.'
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/keys.vue